module.exports = __webpack_public_path__ + "static/media/EYInterstate-Regular.343b70bc.woff2";